
<script lang="ts">
import { defineComponent, computed } from '@vue/composition-api';

import { useAppSnackbarModule } from '@/store/global/appComponents/appSnackbar';

export default defineComponent({
    name: 'AppSnackbar',

    setup() {
        const store = useAppSnackbarModule();
        const state = computed(() => ({
            message: store.state.message,
        }));

        const onActionClick = () => {
            if (state.value.message.onAction) {
                state.value.message.onAction();
            }
            state.value.message.isShown = false;
        };

        return {
            state,
            onActionClick,
        };
    },
});
</script>

<template>
  <div id="snackbar">
    <v-snackbar
      v-model="state.message.isShown"
      :timeout="state.message.timeout"
      class="no-click-outside"
      multi-line
      top
      right
      :color="state.message.type"
    >
      {{ state.message.message }}
      <v-btn
        v-if="state.message.actionText"
        color="white"
        text
        @click="onActionClick"
      >
        {{ state.message.actionText }}
      </v-btn>
      <v-btn
        color="white"
        text
        @click="state.message.isShown = false"
      >
        Close
      </v-btn>
    </v-snackbar>
  </div>
</template>
